interface ActivateOpts {
  focus?: boolean;
}

export function initEvidenceTabs(): void {
  document.querySelectorAll<HTMLElement>(".evidence-tabs").forEach((container) => {
    const tabs = Array.from(container.querySelectorAll<HTMLElement>('[role="tab"]'));
    const panels = Array.from(container.querySelectorAll<HTMLElement>('[role="tabpanel"]'));
    if (!tabs.length) return;

    const activate = (name: string | undefined, { focus = false }: ActivateOpts = {}) => {
      if (!name) return;
      tabs.forEach((t) => {
        const active = t.dataset.tab === name;
        t.setAttribute("aria-selected", active ? "true" : "false");
        t.tabIndex = active ? 0 : -1;
        if (active && focus) t.focus();
      });
      panels.forEach((p) => {
        const active = p.dataset.panel === name;
        if (active) p.removeAttribute("hidden");
        else p.setAttribute("hidden", "");
      });
    };

    const scrolly = container.closest<HTMLElement>(".evidence-scrolly");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const scrollEnabled =
      !!scrolly && window.matchMedia("(min-width: 1024px)").matches && !reduceMotion;

    const scrollToStage = (name: string | undefined) => {
      if (!name) return;
      const stage = document.getElementById("evidence-stage-" + name);
      if (stage) stage.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        if (scrollEnabled) {
          scrollToStage(tab.dataset.tab);
        } else {
          activate(tab.dataset.tab);
        }
      });
      tab.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          const dir = e.key === "ArrowRight" ? 1 : -1;
          const next = tabs[(i + dir + tabs.length) % tabs.length];
          if (next) activate(next.dataset.tab, { focus: true });
        } else if (e.key === "Home") {
          e.preventDefault();
          const first = tabs[0];
          if (first) activate(first.dataset.tab, { focus: true });
        } else if (e.key === "End") {
          e.preventDefault();
          const last = tabs[tabs.length - 1];
          if (last) activate(last.dataset.tab, { focus: true });
        }
      });
    });

    if (scrollEnabled && scrolly) {
      const order = ["geox", "qtlx", "gwasx", "litx"] as const;
      let current: string = order[0];
      let ticking = false;

      const updateFromScroll = () => {
        ticking = false;
        const rect = scrolly.getBoundingClientRect();
        const vh = window.innerHeight;
        // Progress: 0 when scrolly top hits viewport center, 1 when scrolly bottom does.
        const progress = (vh / 2 - rect.top) / rect.height;
        if (progress < 0 || progress > 1) return;
        const idx = Math.min(
          order.length - 1,
          Math.max(0, Math.floor(progress * order.length)),
        );
        const next = order[idx];
        if (next && next !== current) {
          current = next;
          activate(next);
        }
      };

      window.addEventListener(
        "scroll",
        () => {
          if (!ticking) {
            window.requestAnimationFrame(updateFromScroll);
            ticking = true;
          }
        },
        { passive: true },
      );
      updateFromScroll();
    }
  });
}
